import { takeLatest, call } from '@redux-saga/core/effects'
import { put, select } from 'redux-saga/effects'
import { IOptionsResponse } from '../../../common/common.types'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors/getServiceId.selector'
import { OptionsService } from '../services/options.service'
import { setPatientAllergiesMedicationButtonWallOptions } from '../store/options.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { PCRConstants } from '../../pcr/store/pcr.constants'

export function* getPatientAllergiesMedicationButtonWallOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)

  try {
    const patientAllergyMedicationButtonWallOptionsResponse: IOptionsResponse = yield call([
      optionsService,
      optionsService.getPatientAllergiesMedicationButtonWallOptions,
    ])
    const { entity } = patientAllergyMedicationButtonWallOptionsResponse
    yield put(setPatientAllergiesMedicationButtonWallOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getPatientAllergiesMedicationButtonWallOptions() error: ${e}`))
  }
}

export function* getPatientAllergiesMedicationButtonWallOptionsSaga() {
  yield takeLatest(
    [PCRConstants.CREATE_PCR, ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS],
    getPatientAllergiesMedicationButtonWallOptions
  )
}
